import { useEffect, useState } from "react";

/**
 * Live clock hook. Returns the current timestamp (ms) and re-renders
 * the subscriber every `intervalMs` (default: one minute).
 *
 * Purpose: any UI surface that displays a wall-clock time or date
 * should re-read it periodically so the display never lies about what
 * time it is. A minute-resolution tick is plenty for editorial
 * datelines and the sunrise/sunset rail; nothing here needs seconds.
 */
export default function useNow(intervalMs = 60 * 1000) {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);
  return now;
}
